var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component, { mixins } from 'vue-class-component';
import IndexMixins from '../mixins/index';
var pcIndex = /** @class */ (function (_super) {
    __extends(pcIndex, _super);
    function pcIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sliders = [
            // {
            //     img: require("../../static/slider/index-3.jpg")
            // },
            // {
            //     img: require("../../static/slider/index-1.jpg")
            // },
            // {
            //     img: require('../../static/slider/index-4.jpg')
            // },
            // {
            //     img: require('../../static/slider/index-2.jpg')
            // },
            {
                img: require("../../static/slider/index-5.jpg"),
            },
        ];
        _this.img = [
            {
                img: require("../assets/other/02imgSchool.png"),
            },
            {
                img: require("../assets/other/02student.png"),
            },
        ];
        _this.imgtow = [
            {
                img: require("../../static/slider/03BG.jpg"),
            },
        ];
        _this.imgthree = [
            {
                img: require("../../static/slider/Deyubg_01.jpg"),
                imgs: require("../../static/slider/Deyuimg_01.png"),
                content: [
                    {
                        img: require("../assets/other/Deyuicon01.png"),
                        title: "一站式平台",
                        cont: "一个账号通行八大应用平台，统一账户，统一数据，统一交互",
                    },
                    {
                        img: require("../assets/other/Deyuicon02.png"),
                        title: "云定制平台",
                        cont: "千校千面量身定做，学校不同，身份不同，设置不同，真正做到一校一品",
                    },
                    {
                        img: require("../assets/other/Deyuicon03.png"),
                        title: "全终端平台",
                        cont: "全终端任意平台使用，移动端，PC端，任意第三方平台",
                    },
                ],
            },
            {
                img: require("../../static/slider/Deyubg_02.jpg"),
                imgs: require("../../static/slider/Deyuimg_02.png"),
                content: [
                    {
                        img: require("../assets/other/Deyuicon01.png"),
                        title: "50+系统",
                        cont: "满足信息时代教、学、研、管、评需求",
                    },
                    {
                        img: require("../assets/other/Deyuicon02.png"),
                        title: "100+应用",
                        cont: "千校千面，按需定制，覆盖学校全场景应用",
                    },
                    {
                        img: require("../assets/other/Deyuicon03.png"),
                        title: "3000+报表",
                        cont: "灵活设置，促进学校个性化、精细化、智能化管理",
                    },
                ],
            },
            {
                img: require("../../static/slider/Deyubg_03.jpg"),
                imgs: require("../../static/slider/Deyuimg_03.png"),
                content: [
                    {
                        img: require("../assets/other/Deyuicon01.png"),
                        title: "学生成长",
                        cont: "过程性、系统性地全方面勾勒出学生的成长画像",
                    },
                    {
                        img: require("../assets/other/Deyuicon02.png"),
                        title: "学校活动",
                        cont: "实时显示校园活动统计，跟踪学生足迹，引导学生德育全面发展",
                    },
                    {
                        img: require("../assets/other/Deyuicon03.png"),
                        title: "教师发展",
                        cont: "真实记录教师的教育生涯，进一步提升教师的发展",
                    },
                ],
            },
        ];
        _this.schemeData = [
            {
                itemList: [
                    {
                        img: require("../assets/other/class.png"),
                        title: "班级体建设平台",
                        englishTitle: "Class collective construction platform",
                        contList: ["智能多元化评价", " 实时反馈追溯", "工作任务目标导向"],
                    },
                    {
                        img: require("../assets/other/Grownup.png"),
                        title: "学生自主成长平台",
                        englishTitle: "Student self-growth platform",
                        contList: ["考评系统", "教研系统"],
                    },
                    {
                        img: require("../assets/other/Teacher.png"),
                        title: "班主任发展平台",
                        englishTitle: "Class teacher development platform",
                        contList: ["师生互动", "  日常任务系统", "学生成长报告单"],
                    },
                ],
            },
            {
                itemList: [
                    {
                        img: require("../assets/other/Actitive.png"),
                        title: "校园文化活动平台",
                        englishTitle: "Campus cultural activity platform",
                        contList: ["活动管理", " 社团、课程管理", "活动成果分析"],
                    },
                    {
                        img: require("../assets/other/Xinli.png"),
                        title: "心理健康平台",
                        englishTitle: "Labor education platform",
                        contList: ["职业教育阶段心理辅导"],
                    },
                    {
                        img: require("../assets/other/Laodong.png"),
                        title: "劳动教育平台",
                        englishTitle: "Class teacher development platform",
                        contList: ["智慧课堂", "学习提醒"],
                    },
                ],
            },
            {
                itemList: [
                    {
                        img: require("../assets/other/Shixi.png"),
                        title: "实习就业平台",
                        englishTitle: "Internship employment platform",
                        contList: ["岗位招聘", "  企业实习", " 就业分析"],
                    },
                    {
                        img: require("../assets/other/Liucheng.png"),
                        title: "流程管理平台",
                        englishTitle: "Process management platform",
                        contList: ["请假、宿舍流程", "多方通知(宿管、门卫)"],
                    },
                ],
            },
        ];
        return _this;
    }
    pcIndex = __decorate([
        Component
    ], pcIndex);
    return pcIndex;
}(mixins(IndexMixins)));
export default pcIndex;
